import invTypeDetailDialog from './view/invTypeDetail.html'

class statisticsTaxRateListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, treeSelectService) {
        const userInfo = JSON.parse(localStorage.user_info)
        $scope.dictData = {}
        $scope.dictData.cancel_status = [
            { enumTypeCode: null, enumName: '正常', enumCode: '0' },
            { enumTypeCode: null, enumName: '已作废', enumCode: '1' },
        ]
        const typecodeArr = ['inv_type', 'invoice_status', 'is_red']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        // 下拉机构组件配置
        $scope.queryOrgConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'statistTree',
            parentIdName: 'parentOrgId',
            multiple: true,
            parentId: userInfo.org.parentOrgId,
            defaultSelect: [],
        }
        // 下拉销方
        $scope.querySaleConfig = {
            queryName: 'saleName',
            queryKey: 'saleId',
            queryType: 'Flater',
            parentIdName: 'parentSaleId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                invType: '',
                invoiceDateMax: initDate(),
                invoiceDateMin: initDate(),
                cancelStatus: '',
                isRed: '',
                orgIdList: [userInfo.user.currentOrgId],
                saleIdList: [],
                ukeyIdList: [],
                // accessToken: idToken,
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                invType: '',
                invoiceDateMax: initDate(),
                invoiceDateMin: initDate(),
                cancelStatus: '',
                isRed: '',
                orgIdList: [userInfo.user.currentOrgId],
                saleIdList: [],
                ukeyIdList: [],
                // accessToken: idToken,
            }
            $scope.queryOrgConfig.defaultSelect = defaultOrg
            $scope.querySaleConfig.defaultSelect = []
        }
        // $scope.reset()
        let defaultOrg = []
        $scope.datePickerConfig = {
            format: 'yyyy-mm',
            minView: 3,
            startView: 3,
        }
        $scope.customizedConfig = {
            version: 1.01,
            queryConfig: [
                {
                    label: '所属月份起止',
                    selected: true,
                    default: true,
                }, {
                    label: '销方名称',
                    selected: true,
                    default: true,
                }, {
                    label: '发票种类',
                    selected: false,
                    default: false,
                }, {
                    label: '发票性质',
                    selected: false,
                    default: false,
                }, {
                    label: '开票机构筛选',
                    selected: false,
                    default: false,
                }],
        }
        // 更新时间
        $scope.latestUpdateTime = ''
        httpRequest.get_getEffectiveTaxRate().then((res) => {
            const { value } = res.data
            $scope.taxRateThList = value.reduce((total, item) => {
                total.push(item.taxRatePercent === '0%' ? '其他' : item.taxRatePercent)
                return total
            }, [])
            $scope.taxRateSuffixArr = value.reduce((total, item) => {
                total.push(item.taxRateSuffix)
                return total
            }, [])
        })


        $scope.orgList = [] // 机构
        $scope.saleList = [] // 销方

        // 时间格式初始化
        function initDate (month, year) {
            const date = new Date()
            const y = year || date.getFullYear()
            let m = month || date.getMonth() + 1
            m = m < 10 ? `0${m}` : m
            return `${y}-${m}`
        }
        // 机构变化
        $scope.orgSelectChange = function (v) {
            const orgSelectArr = v
            const orgSelectL = orgSelectArr.length
            if (orgSelectL > 0) {
                $scope.param.param.orgIdList = orgSelectArr.map((item) => item.orgId)
            } else {
                $scope.param.param.orgIdList = []
            }
            $scope.param.param.ukeyIdList = []
            $scope.queryOrgConfig.defaultSelect = v
            httpRequest.post_qryUkeyListOfOrgIds($scope.param.param.orgIdList).then((res) => {
                if (res.data.success) {
                    $scope.ukeyList = treeSelectService(res.data.value, 'ukeyId', 'ukeyName')
                    $scope.ukeyListArr = treeSelectService(res.data.value, 'ukeyId', 'ukeyName') // 当前开票点
                }
            })
        }

        // 销方变化
        $scope.saleSelectChange = function (v) {
            const saleSelectArr = v
            const saleSelectL = saleSelectArr.length
            if (saleSelectL > 0) {
                $scope.param.param.saleIdList = saleSelectArr.map((item) => item.saleId)
            } else {
                $scope.param.param.saleIdList = []
            }
        }
        httpRequest.get_getUserOrgList().then((res) => {
            if (res.data.success) {
                $scope.orgList = res.data.value
                $scope.queryOrgConfig.defaultSelect = res.data.value.filter((item) => item.orgId === userInfo.user.currentOrgId)
                defaultOrg = res.data.value.filter((item) => item.orgId === userInfo.user.currentOrgId)
                // 返回机构名称
                $scope.fliterOrgName = function (id) {
                    if (id === null) {
                        return id
                    }
                    if (res.data.value === null) {
                        return id
                    }
                    const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                    if (fliterUkeyNameArr.length > 0) {
                        return fliterUkeyNameArr[0].orgName
                    }
                    return id
                }
                // 返回销方数组
                const _orgIdList = res.data.value.map((item) => item.orgId)
                httpRequest.post_qryUkeyListOfOrgIds($scope.param.param.orgIdList).then((res) => {
                    if (res.data.success) {
                        $scope.ukeyList = treeSelectService(res.data.value, 'ukeyId', 'ukeyName')
                        $scope.ukeyListArr = treeSelectService(res.data.value, 'ukeyId', 'ukeyName') // 当前开票点

                        $scope.fliterUkeyName = function (id) {
                            if (id === null) {
                                return id
                            }
                            if ($scope.ukeyListArr === null || $scope.ukeyListArr.length === 0) {
                                return id
                            }
                            const fliterUkeyNameArr = $scope.ukeyListArr.filter((item) => item.ukeyId === id)
                            if (fliterUkeyNameArr.length > 0) {
                                return fliterUkeyNameArr[0].ukeyName
                            }
                            return id
                        }
                        queryInfo()
                    }
                })
                // 销方
                if (_orgIdList.length > 0) {
                    httpRequest.post_getSaleInfoListByOrgIds(_orgIdList).then((res) => {
                        $scope.saleList = treeSelectService(res.data, 'saleId', 'saleName')
                    })
                }
            }
        })

        httpRequest.get_queryStatTime({ reportId: 2 }).then((res) => {
            $scope.latestUpdateTime = res.data.value.lastStatTime
            $scope.dataBeginDate = res.data.value.dataBeginDate
        })
        // 导出
        $scope.exportInvoic = function () {
            httpRequest.get_exportInvoiceRateToXLS($.extend({accessToken:localStorage.id_token},$scope.param.param))
        }


        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数


        $scope.pageChanged = function () { // 点击页码发起查询
            queryInfo()
        }

        /**
         * 计算1. 每个税号下的机构数，2. 每个机构下月份数  3. 每个月份下发票种类数
         * 不能以查询条件计算 以实际数据为准
         * @param  {array}  list 统计列表数据
         * @return {object}      计算结果示例如下
         * {
         *     `44039999`: 2, // 4403999..税号下有2个机构有数据
         *     `44039999${orgId4}`: 2,  // 4403999税号下orgId为4的机构下有2个月数据
         *     `44039999${orgId4}${month(2018-11)}`: 2  // 4403999税号下orgId为4的机构下11月有2种发票有数据
         *     ...
         * }
         */
        function countResult (list) {
            let preRow = list.shift()
            const counts = {}
            counts[preRow.saleCreditCode] = 1
            // 同税号同机构下月份数
            counts[`${preRow.saleCreditCode}${preRow.invoiceOrgId}`] = 1
            // 同税号同机构同月份下发票种类数
            counts[`${preRow.saleCreditCode}${preRow.invoiceOrgId}${preRow.invoiceMonth}`] = 1
            while (list.length > 0) {
                const listItem = list.shift()
                if (listItem.saleCreditCode === preRow.saleCreditCode) {
                    if (listItem.invoiceOrgId !== preRow.invoiceOrgId) {
                        // 该税号下机构数加1
                        counts[listItem.saleCreditCode] += 1
                        // 该机构下月份数 初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invoiceMonth !== preRow.invoiceMonth) {
                        // month + 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] += 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invType !== preRow.invType) {
                        counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] += 1
                    }
                } else {
                    // 税号下机构数
                    counts[listItem.saleCreditCode] = 1
                    // 同税号同机构下月份数
                    counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                    // 同税号同机构同月份下发票种类数
                    counts[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            }
            return counts
        }

        function getRowsapns (list) {
            let preRow = list.shift()
            const rowspan = {}
            rowspan[preRow.saleCreditCode] = 1
            // 同税号同机构下月份数
            rowspan[`${preRow.saleCreditCode}${preRow.invoiceOrgId}`] = 1
            // 同税号同机构同月份下发票种类数
            rowspan[`${preRow.saleCreditCode}${preRow.invoiceOrgId}${preRow.invoiceMonth}`] = 1
            while (list.length > 0) {
                const listItem = list.shift()
                if (!$scope.isShowThisRow(listItem)) {
                    continue
                }
                if (listItem.saleCreditCode === preRow.saleCreditCode) {
                    rowspan[listItem.saleCreditCode] += 1
                    if (listItem.invoiceOrgId === preRow.invoiceOrgId) {
                        rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] += 1
                        if (listItem.invoiceMonth === preRow.invoiceMonth) {
                            rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] += 1
                        } else {
                            rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                        }
                    } else {
                        rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                        rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                    }
                } else {
                    // 税号下机构数
                    rowspan[listItem.saleCreditCode] = 1
                    // 同税号同机构下月份数
                    rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}`] = 1
                    // 同税号同机构同月份下发票种类数
                    rowspan[`${listItem.saleCreditCode}${listItem.invoiceOrgId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            }
            return rowspan
        }


        function countResultWhileNoOrg (list) {
            let preRow = list.shift()
            const counts = {}
            // 同税号同机构下月份数
            counts[preRow.saleCreditCode] = 1
            // 同税号同机构同月份下发票种类数
            counts[`${preRow.saleCreditCode}${preRow.invoiceMonth}`] = 1
            do {
                const listItem = list.shift()
                if (listItem.saleCreditCode === preRow.saleCreditCode) {
                    if (listItem.invoiceMonth !== preRow.invoiceMonth) {
                        // month + 1
                        counts[`${listItem.saleCreditCode}`] += 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.saleCreditCode}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invType !== preRow.invType) {
                        counts[`${listItem.saleCreditCode}${listItem.invoiceMonth}`] += 1
                    }
                } else {
                    // 同税号同机构下月份数
                    counts[listItem.saleCreditCode] = 1
                    // 同税号同机构同月份下发票种类数
                    counts[`${listItem.saleCreditCode}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            } while (list.length > 0)
            return counts
        }

        $scope.getMonthRowspan = function getMonthRowspan (item) {
            return $scope.rowspans[`${item.saleCreditCode}${item.invoiceOrgId}${item.invoiceMonth}`]
        }

        $scope.getOrgRowspan = function getOrgRowspan (item) {
            return $scope.rowspans[`${item.saleCreditCode}${item.invoiceOrgId}`]
        }

        $scope.getCreditRowspan = function getCreditRowspan (item) {
            return $scope.rowspans[item.saleCreditCode]
        }

        $scope.isShowThisRow = function isShowThisRow (item) {
            let orgCount
            let monthCount
            let invTypeCount
            if ($scope.showOrgCol) {
                orgCount = $scope.counts[item.saleCreditCode]
                monthCount = $scope.counts[`${item.saleCreditCode}${item.invoiceOrgId}`]
                invTypeCount = $scope.counts[`${item.saleCreditCode}${item.invoiceOrgId}${item.invoiceMonth}`]
            } else {
                monthCount = $scope.counts[`${item.saleCreditCode}`]
                invTypeCount = $scope.counts[`${item.saleCreditCode}${item.invoiceMonth}`]
            }

            if (item.invType === '9999999' && invTypeCount === 2) {
                return false
            }
            if (orgCount === 2 && item.invoiceOrgId === '9999999') {
                return false
            }
            // 只选了一个月不显示月小计行
            if (monthCount === 2 && item.invoiceMonth === '9999999') {
                return false
            }
            // 1.不选机构按税号统计 2.只选择一个月
            if (monthCount === 2 && !$scope.showOrgCol && item.invoiceMonth === '9999999') {
                return false
            }
            return true
        }

        $scope.isShowThisCredit = function isShowThisCredit (item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.saleCreditCode !== item.saleCreditCode
        }
        $scope.isShowThisOrg = function isShowThisOrg (item, index) {
            if (!$scope.showOrgCol) {
                return false
            }
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.saleCreditCode !== item.saleCreditCode
                || preRow.invoiceOrgId !== item.invoiceOrgId
        }

        $scope.isShowThisMonth = function isShowThisMonth (item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            if ($scope.showOrgCol) {
                return preRow.saleCreditCode !== item.saleCreditCode
                    || preRow.invoiceOrgId !== item.invoiceOrgId
                    || preRow.invoiceMonth !== item.invoiceMonth
            }
            return preRow.saleCreditCode !== item.saleCreditCode
                || preRow.invoiceMonth !== item.invoiceMonth
        }
        // let isSearch = false
        // $scope.$watch('param', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('statistics.outputStatistics.statisticsTaxRate') != -1) {
        //         isSearch && sessionStorage.setItem('taxRateParam', JSON.stringify($scope.param))
        //     }
        // })
        function queryInfo () {
            const invoiceDateMaxTmp = new Date($scope.param.param.invoiceDateMax)
            const invoiceDateMinTmp = new Date($scope.param.param.invoiceDateMin)
            if (overOneYear(invoiceDateMaxTmp, invoiceDateMinTmp)) {
                logger.logError('[所属月份起止]起始结束时间跨度不能超过一年')
                return
            }
            $scope.param = sessionStorage.taxRateParam ? JSON.parse(sessionStorage.taxRateParam) : $scope.param
            if ($scope.ukeyList.length > 0) {
                $scope.ukeyListArr = treeSelectService($scope.ukeyList, 'ukeyId', 'ukeyName')
            }
            if ($scope.param.param.isRed !== '' && $scope.param.param.cancelStatus !== '') {
                $scope.showisRedAndcancelStatus = true
            } else {
                $scope.showisRedAndcancelStatus = false
            }

            if ($scope.param.param.orgIdList.length !== 0) {
                $scope.showOrgCol = true
            } else {
                $scope.showOrgCol = false
            }
            if ($scope.param.param.ukeyIdList.length !== 0) {
                $scope.showUkeyRow = true
            } else {
                $scope.showUkeyRow = false
            }
            $scope.saleGrade = saleGradeFn()
            $scope.orgGrade = orgGradeFn()
            httpRequest.post_qryBiInvoiceRateList($scope.param).then((res) => {
                const listData = res.data.value.list
                $scope.lastParam = { ...$scope.param.param }
                $scope.listData = listData
                $scope.param.pageNum = res.data.value.pageNum
                if (listData.length === 0) {
                    return
                }
                if ($scope.showOrgCol) {
                    $scope.counts = countResult(listData.slice())
                } else {
                    $scope.counts = countResultWhileNoOrg(listData.slice())
                }
                $scope.rowspans = getRowsapns(listData.slice())
            })
        }

        function overOneYear (max, min) {
            const dateMaxTmp = new Date(max)
            const dateMinTmp = new Date(min)

            const dateMaxYear = dateMaxTmp.getFullYear()
            const dateMaxMonth = dateMaxTmp.getMonth()

            const dateMinYear = dateMinTmp.getFullYear()
            const dateMinMonth = dateMinTmp.getMonth()

            return (dateMaxYear - dateMinYear > 1) || (dateMaxYear - dateMinYear === 1) && (dateMaxMonth - dateMinMonth > -1)
        }
        // 是否展示发票性质和发票状态
        $scope.showisRedAndcancelStatus = false
        // 是否展示机构
        $scope.showOrgCol = false
        // 是否展示开票点
        $scope.showUkeyRow = false

        // 销方粒度
        $scope.saleGrade = true
        function saleGradeFn () {
            return $scope.param.param.orgIdList.length === 0 && $scope.param.param.ukeyIdList.length === 0
        }
        // 机构粒度
        $scope.orgGrade = false
        function orgGradeFn () {
            return $scope.param.param.orgIdList.length > 0 && $scope.param.param.ukeyIdList.length === 0
        }
        $scope.toOrgIdDetailPage = function toOrgIdDetailPage (item) {
            $state.go('statistics.outputStatistics.statisticsTaxRate.detail', {
                param: JSON.stringify({
                    invType: $scope.lastParam.invType,
                    invoiceDateMax: $scope.lastParam.invoiceDateMax,
                    invoiceDateMin: $scope.lastParam.invoiceDateMin,
                    isRed: $scope.lastParam.isRed,
                    invoiceOrgId: item.invoiceOrgId,
                }),
            })
            localStorage.setItem(
                'taxStatisticsDetail',
                JSON.stringify({
                    invType: $scope.lastParam.invType,
                    invoiceDateMax: $scope.lastParam.invoiceDateMax,
                    invoiceDateMin: $scope.lastParam.invoiceDateMin,
                    isRed: $scope.lastParam.isRed,
                    invoiceOrgId: item.invoiceOrgId,
                    saleName: item.saleName,
                    saleCreditCode: item.saleCreditCode,
                    orgName: item.orgName,
                }),
            )
        }
        // 搜索
        $scope.searchlist = function () { // 点击搜索发起查询
            sessionStorage.setItem('taxRateParam', JSON.stringify($scope.param))
            queryInfo()
        }

        $scope.openInvTypeDetail = function openInvTypeDetail (item) {
            if (item.invoiceMonth === '9999999') {
                return
            }
            const param = {
                invType: item.invType,
                invoiceDateMax: item.invoiceMonth,
                invoiceDateMin: item.invoiceMonth,
                cancelStatus: $scope.param.param.cancelStatus,
                isRed: $scope.param.param.isRed,
                orgIdList: [item.invoiceOrgId],
                saleIdList: [item.saleId],
            }
            if ($scope.lastParam.orgIdList.length === 0 && $scope.lastParam.saleIdList.length === 0) {
                const userInfo = JSON.parse(localStorage.getItem('user_info'))
                const currentOrgId = userInfo.org.orgId
                param.orgIdList = [currentOrgId]
            }
            httpRequest.post_queryIsRedInvoiceList(param).then((res) => {
                $uibModal.open({
                    template: invTypeDetailDialog,
                    controller: ['$scope', '$uibModalInstance', (scope, uibModalInstance) => {
                        scope.result = res.data.value
                        if ($scope.lastParam.isRed === '1') {
                            scope.result.splice(0, 1)
                        } else if ($scope.lastParam.isRed === '0') {
                            scope.result.splice(1)
                        }
                        scope.cancel = function cancel () {
                            uibModalInstance.dismiss('sz')
                        }
                        scope.taxRateThList = $scope.taxRateThList
                        scope.taxRateSuffixArr = $scope.taxRateSuffixArr
                    }],
                    openedClass: 'mod-modal mod-modal-hg',
                    backdrop: 'static',
                })
            })
        }
    }
}
statisticsTaxRateListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'treeSelectService']
export default statisticsTaxRateListCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsTaxRate/statisticsTaxRateListCtrl.js